"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplaintState = exports.AssignedResponsibility = exports.ResolutionType = exports.PriceType = exports.InvoiceOrigin = exports.PurchaseOrderState = exports.ReportState = exports.OrderOrigin = exports.OrderState = exports.RecycleType = exports.ShelfLife = exports.AlcoholTaxClass = exports.Color = exports.ComplaintType = exports.TargetWarehouse = exports.DeviationReason = exports.OrderFlowType = exports.DeliveryPalletType = exports.TransportProvider = exports.OrderType = exports.ExciseProductCode = exports.KnNumber = exports.SalesAccount = exports.Seal = exports.StorageTemperature = exports.RecycleTypePallet = exports.RecycleTypeContainer = exports.Container = exports.PriceComparisonUnit = exports.OrderUnit = exports.Name = exports.PreDefinedAccount = exports.DeliveryCounty = exports.InvoiceCountry = exports.TermsOfPayment = exports.DeliveryCountry = void 0;
__exportStar(require("../shared"), exports);
__exportStar(require("./extension"), exports);
var DeliveryCountry;
(function (DeliveryCountry) {
    DeliveryCountry["SE"] = "SE";
    DeliveryCountry["FI"] = "FI";
    DeliveryCountry["NO"] = "NO";
    DeliveryCountry["DK"] = "DK";
    DeliveryCountry["IS"] = "IS";
})(DeliveryCountry || (exports.DeliveryCountry = DeliveryCountry = {}));
/**
 * Must have a value if not readonly else fortnox bails
 */
var TermsOfPayment;
(function (TermsOfPayment) {
    TermsOfPayment["num_0"] = "0";
    TermsOfPayment["num_10"] = "10";
    TermsOfPayment["num_15"] = "15";
    TermsOfPayment["num_20"] = "20";
    TermsOfPayment["num_30"] = "30";
    TermsOfPayment["num_35"] = "35";
    TermsOfPayment["num_60"] = "60";
    TermsOfPayment["num_70"] = "70";
    TermsOfPayment["A"] = "A";
    TermsOfPayment["K"] = "K";
    TermsOfPayment["PF"] = "PF";
})(TermsOfPayment || (exports.TermsOfPayment = TermsOfPayment = {}));
var InvoiceCountry;
(function (InvoiceCountry) {
    InvoiceCountry["SE"] = "SE";
    InvoiceCountry["FI"] = "FI";
    InvoiceCountry["NO"] = "NO";
    InvoiceCountry["DK"] = "DK";
    InvoiceCountry["IS"] = "IS";
})(InvoiceCountry || (exports.InvoiceCountry = InvoiceCountry = {}));
var DeliveryCounty;
(function (DeliveryCounty) {
    DeliveryCounty["SE-O"] = "SE-O";
    DeliveryCounty["SE-N"] = "SE-N";
    DeliveryCounty["SE-M"] = "SE-M";
    DeliveryCounty["SE-K"] = "SE-K";
    DeliveryCounty["SE-I"] = "SE-I";
    DeliveryCounty["SE-H"] = "SE-H";
    DeliveryCounty["SE-G"] = "SE-G";
    DeliveryCounty["SE-F"] = "SE-F";
    DeliveryCounty["SE-E"] = "SE-E";
    DeliveryCounty["SE-D"] = "SE-D";
    DeliveryCounty["SE-C"] = "SE-C";
    DeliveryCounty["SE-Z"] = "SE-Z";
    DeliveryCounty["SE-Y"] = "SE-Y";
    DeliveryCounty["SE-X"] = "SE-X";
    DeliveryCounty["SE-W"] = "SE-W";
    DeliveryCounty["SE-BD"] = "SE-BD";
    DeliveryCounty["SE-T"] = "SE-T";
    DeliveryCounty["SE-S"] = "SE-S";
    DeliveryCounty["SE-U"] = "SE-U";
    DeliveryCounty["SE-AC"] = "SE-AC";
    DeliveryCounty["SE-AB"] = "SE-AB";
})(DeliveryCounty || (exports.DeliveryCounty = DeliveryCounty = {}));
var PreDefinedAccount;
(function (PreDefinedAccount) {
    PreDefinedAccount["num_4000"] = "4000";
    PreDefinedAccount["num_4004"] = "4004";
    PreDefinedAccount["num_4005"] = "4005";
    PreDefinedAccount["num_4010"] = "4010";
    PreDefinedAccount["num_4011"] = "4011";
    PreDefinedAccount["num_4014"] = "4014";
    PreDefinedAccount["num_4017"] = "4017";
})(PreDefinedAccount || (exports.PreDefinedAccount = PreDefinedAccount = {}));
/**
 * Artikelns normliserade enhet
 */
var Name;
(function (Name) {
    Name["lav"] = "lav";
    Name["bag_in_box"] = "bag_in_box";
    Name["PET"] = "PET";
    Name["pallet"] = "pallet";
    Name["package"] = "package";
    Name["pcs"] = "pcs";
    Name["kg"] = "kg";
    Name["hg"] = "hg";
    Name["g"] = "g";
    Name["liter"] = "liter";
    Name["dl"] = "dl";
    Name["cl"] = "cl";
    Name["ml"] = "ml";
    Name["case"] = "case";
    Name["crate"] = "crate";
    Name["bale"] = "bale";
    Name["big_box"] = "big_box";
    Name["piece"] = "piece";
    Name["block"] = "block";
    Name["book"] = "book";
    Name["tray"] = "tray";
    Name["bouquet"] = "bouquet";
    Name["bundle"] = "bundle";
    Name["can"] = "can";
    Name["tub"] = "tub";
    Name["mug"] = "mug";
    Name["big_can"] = "big_can";
    Name["disposable_glass"] = "disposable_glass";
    Name["barrel"] = "barrel";
    Name["package4"] = "package4";
    Name["bottle"] = "bottle";
    Name["braid"] = "braid";
    Name["package2"] = "package2";
    Name["glass"] = "glass";
    Name["bucket"] = "bucket";
    Name["keg"] = "keg";
    Name["capsules"] = "capsules";
    Name["sv_karta"] = "sv_karta";
    Name["carton"] = "carton";
    Name["cassette"] = "cassette";
    Name["bunch"] = "bunch";
    Name["bundle2"] = "bundle2";
    Name["basket"] = "basket";
    Name["pot"] = "pot";
    Name["quarter_pallet"] = "quarter_pallet";
    Name["box"] = "box";
    Name["bulk"] = "bulk";
    Name["m"] = "m";
    Name["m2"] = "m2";
    Name["net"] = "net";
    Name["package3"] = "package3";
    Name["package5"] = "package5";
    Name["bag"] = "bag";
    Name["recycle_glass"] = "recycle_glass";
    Name["roll"] = "roll";
    Name["side"] = "side";
    Name["sack"] = "sack";
    Name["tetra"] = "tetra";
    Name["trough"] = "trough";
    Name["tube"] = "tube";
    Name["wagon"] = "wagon";
    Name["unknown"] = "unknown";
})(Name || (exports.Name = Name = {}));
var OrderUnit;
(function (OrderUnit) {
    OrderUnit["package"] = "package";
    OrderUnit["single"] = "single";
    OrderUnit["weight"] = "weight";
})(OrderUnit || (exports.OrderUnit = OrderUnit = {}));
var PriceComparisonUnit;
(function (PriceComparisonUnit) {
    PriceComparisonUnit["unit"] = "unit";
    PriceComparisonUnit["kg"] = "kg";
    PriceComparisonUnit["liter"] = "liter";
})(PriceComparisonUnit || (exports.PriceComparisonUnit = PriceComparisonUnit = {}));
/**
 * drycksadmin har pet, flaska, burk
 */
var Container;
(function (Container) {
    Container["Can"] = "Can";
    Container["Bottle"] = "Bottle";
    Container["Keg"] = "Keg";
    Container["Tetra"] = "Tetra";
    Container["Paper"] = "Paper";
    Container["BIB"] = "BIB";
    Container["Bag"] = "Bag";
    Container["Pet"] = "Pet";
    Container["Box"] = "Box";
    Container["Pot"] = "Pot";
    Container["Carton"] = "Carton";
    Container["Plastic can"] = "Plastic can";
    Container["TinCan"] = "TinCan";
    Container["Vacuum-sealed"] = "Vacuum-sealed";
    Container["Other"] = "Other";
})(Container || (exports.Container = Container = {}));
var RecycleTypeContainer;
(function (RecycleTypeContainer) {
    RecycleTypeContainer["none"] = "none";
    RecycleTypeContainer["recyclableQuarterTray"] = "recyclableQuarterTray";
    RecycleTypeContainer["trayLarge"] = "trayLarge";
})(RecycleTypeContainer || (exports.RecycleTypeContainer = RecycleTypeContainer = {}));
var RecycleTypePallet;
(function (RecycleTypePallet) {
    RecycleTypePallet["none"] = "none";
    RecycleTypePallet["recyclableGreySrsPlasticPallet"] = "recyclableGreySrsPlasticPallet";
    RecycleTypePallet["recyclableWoodenHalfPallet"] = "recyclableWoodenHalfPallet";
    RecycleTypePallet["recyclableEuroWoodPallet"] = "recyclableEuroWoodPallet";
    RecycleTypePallet["recyclableBPallet"] = "recyclableBPallet";
    RecycleTypePallet["recyclableAPallet"] = "recyclableAPallet";
    RecycleTypePallet["recylablePlasticPallet"] = "recylablePlasticPallet";
    RecycleTypePallet["reyclingFeePlasticPallet"] = "reyclingFeePlasticPallet";
    RecycleTypePallet["recyclablePlasticHalfPallet"] = "recyclablePlasticHalfPallet";
    RecycleTypePallet["greySrsPlasticPallet"] = "greySrsPlasticPallet";
    RecycleTypePallet["srsBox"] = "srsBox";
    RecycleTypePallet["srsBox2"] = "srsBox2";
})(RecycleTypePallet || (exports.RecycleTypePallet = RecycleTypePallet = {}));
var StorageTemperature;
(function (StorageTemperature) {
    StorageTemperature["frozen"] = "frozen";
    StorageTemperature["refrigerated"] = "refrigerated";
})(StorageTemperature || (exports.StorageTemperature = StorageTemperature = {}));
var Seal;
(function (Seal) {
    Seal["CROWN CORK CAP"] = "CROWN CORK CAP";
    Seal["GLASS CAP"] = "GLASS CAP";
    Seal["NATURAL CORK"] = "NATURAL CORK";
    Seal["SCREW CAP"] = "SCREW CAP";
    Seal["SYNTHETIC CORK"] = "SYNTHETIC CORK";
    Seal["UNCLASSIFIED"] = "UNCLASSIFIED";
    Seal["UNIDENTIFIED"] = "UNIDENTIFIED";
})(Seal || (exports.Seal = Seal = {}));
var SalesAccount;
(function (SalesAccount) {
    SalesAccount["num_3005"] = "3005";
    SalesAccount["num_3004"] = "3004";
    SalesAccount["num_3011"] = "3011";
    SalesAccount["num_3010"] = "3010";
    SalesAccount["num_3017"] = "3017";
    SalesAccount["num_3014"] = "3014";
    SalesAccount["num_3000"] = "3000";
})(SalesAccount || (exports.SalesAccount = SalesAccount = {}));
var KnNumber;
(function (KnNumber) {
    KnNumber["num_15071010"] = "15071010";
    KnNumber["num_15079010"] = "15079010";
    KnNumber["num_15081010"] = "15081010";
    KnNumber["num_15089010"] = "15089010";
    KnNumber["num_15092000"] = "15092000";
    KnNumber["num_15093000"] = "15093000";
    KnNumber["num_15094000"] = "15094000";
    KnNumber["num_15099000"] = "15099000";
    KnNumber["num_15101000"] = "15101000";
    KnNumber["num_15109000"] = "15109000";
    KnNumber["num_15111010"] = "15111010";
    KnNumber["num_15119011"] = "15119011";
    KnNumber["num_15119019"] = "15119019";
    KnNumber["num_15119091"] = "15119091";
    KnNumber["num_15121110"] = "15121110";
    KnNumber["num_15121910"] = "15121910";
    KnNumber["num_15122110"] = "15122110";
    KnNumber["num_15122910"] = "15122910";
    KnNumber["num_15131110"] = "15131110";
    KnNumber["num_15131911"] = "15131911";
    KnNumber["num_15131919"] = "15131919";
    KnNumber["num_15131930"] = "15131930";
    KnNumber["num_15132110"] = "15132110";
    KnNumber["num_15132911"] = "15132911";
    KnNumber["num_15132919"] = "15132919";
    KnNumber["num_15132930"] = "15132930";
    KnNumber["num_15141110"] = "15141110";
    KnNumber["num_15141910"] = "15141910";
    KnNumber["num_15149110"] = "15149110";
    KnNumber["num_15149910"] = "15149910";
    KnNumber["num_15151100"] = "15151100";
    KnNumber["num_15151910"] = "15151910";
    KnNumber["num_15152110"] = "15152110";
    KnNumber["num_15152910"] = "15152910";
    KnNumber["num_15153090"] = "15153090";
    KnNumber["num_15155011"] = "15155011";
    KnNumber["num_15155091"] = "15155091";
    KnNumber["num_15156011"] = "15156011";
    KnNumber["num_15156060"] = "15156060";
    KnNumber["num_15159011"] = "15159011";
    KnNumber["num_15159021"] = "15159021";
    KnNumber["num_15159031"] = "15159031";
    KnNumber["num_15159040"] = "15159040";
    KnNumber["num_15159060"] = "15159060";
    KnNumber["num_15161010"] = "15161010";
    KnNumber["num_15161090"] = "15161090";
    KnNumber["num_15162010"] = "15162010";
    KnNumber["num_15162091"] = "15162091";
    KnNumber["num_15162095"] = "15162095";
    KnNumber["num_15163091"] = "15163091";
    KnNumber["num_15171010"] = "15171010";
    KnNumber["num_15171090"] = "15171090";
    KnNumber["num_15179010"] = "15179010";
    KnNumber["num_15179091"] = "15179091";
    KnNumber["num_15179093"] = "15179093";
    KnNumber["num_15179099"] = "15179099";
    KnNumber["num_15180010"] = "15180010";
    KnNumber["num_15180031"] = "15180031";
    KnNumber["num_15180039"] = "15180039";
    KnNumber["num_15180095"] = "15180095";
    KnNumber["num_22030001"] = "22030001";
    KnNumber["num_22030009"] = "22030009";
    KnNumber["num_22030010"] = "22030010";
    KnNumber["num_22041011"] = "22041011";
    KnNumber["num_22041013"] = "22041013";
    KnNumber["num_22041015"] = "22041015";
    KnNumber["num_22041091"] = "22041091";
    KnNumber["num_22041093"] = "22041093";
    KnNumber["num_22041094"] = "22041094";
    KnNumber["num_22041096"] = "22041096";
    KnNumber["num_22041098"] = "22041098";
    KnNumber["num_22042106"] = "22042106";
    KnNumber["num_22042107"] = "22042107";
    KnNumber["num_22042108"] = "22042108";
    KnNumber["num_22042109"] = "22042109";
    KnNumber["num_22042111"] = "22042111";
    KnNumber["num_22042112"] = "22042112";
    KnNumber["num_22042113"] = "22042113";
    KnNumber["num_22042117"] = "22042117";
    KnNumber["num_22042118"] = "22042118";
    KnNumber["num_22042119"] = "22042119";
    KnNumber["num_22042122"] = "22042122";
    KnNumber["num_22042123"] = "22042123";
    KnNumber["num_22042124"] = "22042124";
    KnNumber["num_22042126"] = "22042126";
    KnNumber["num_22042127"] = "22042127";
    KnNumber["num_22042128"] = "22042128";
    KnNumber["num_22042131"] = "22042131";
    KnNumber["num_22042132"] = "22042132";
    KnNumber["num_22042134"] = "22042134";
    KnNumber["num_22042136"] = "22042136";
    KnNumber["num_22042137"] = "22042137";
    KnNumber["num_22042138"] = "22042138";
    KnNumber["num_22042142"] = "22042142";
    KnNumber["num_22042143"] = "22042143";
    KnNumber["num_22042144"] = "22042144";
    KnNumber["num_22042146"] = "22042146";
    KnNumber["num_22042147"] = "22042147";
    KnNumber["num_22042148"] = "22042148";
    KnNumber["num_22042161"] = "22042161";
    KnNumber["num_22042162"] = "22042162";
    KnNumber["num_22042166"] = "22042166";
    KnNumber["num_22042167"] = "22042167";
    KnNumber["num_22042168"] = "22042168";
    KnNumber["num_22042169"] = "22042169";
    KnNumber["num_22042171"] = "22042171";
    KnNumber["num_22042174"] = "22042174";
    KnNumber["num_22042176"] = "22042176";
    KnNumber["num_22042177"] = "22042177";
    KnNumber["num_22042178"] = "22042178";
    KnNumber["num_22042179"] = "22042179";
    KnNumber["num_22042180"] = "22042180";
    KnNumber["num_22042181"] = "22042181";
    KnNumber["num_22042182"] = "22042182";
    KnNumber["num_22042183"] = "22042183";
    KnNumber["num_22042184"] = "22042184";
    KnNumber["num_22042185"] = "22042185";
    KnNumber["num_22042186"] = "22042186";
    KnNumber["num_22042187"] = "22042187";
    KnNumber["num_22042188"] = "22042188";
    KnNumber["num_22042189"] = "22042189";
    KnNumber["num_22042190"] = "22042190";
    KnNumber["num_22042191"] = "22042191";
    KnNumber["num_22042193"] = "22042193";
    KnNumber["num_22042194"] = "22042194";
    KnNumber["num_22042195"] = "22042195";
    KnNumber["num_22042196"] = "22042196";
    KnNumber["num_22042197"] = "22042197";
    KnNumber["num_22042198"] = "22042198";
    KnNumber["num_22042210"] = "22042210";
    KnNumber["num_22042222"] = "22042222";
    KnNumber["num_22042223"] = "22042223";
    KnNumber["num_22042224"] = "22042224";
    KnNumber["num_22042226"] = "22042226";
    KnNumber["num_22042227"] = "22042227";
    KnNumber["num_22042228"] = "22042228";
    KnNumber["num_22042232"] = "22042232";
    KnNumber["num_22042233"] = "22042233";
    KnNumber["num_22042238"] = "22042238";
    KnNumber["num_22042278"] = "22042278";
    KnNumber["num_22042279"] = "22042279";
    KnNumber["num_22042280"] = "22042280";
    KnNumber["num_22042281"] = "22042281";
    KnNumber["num_22042282"] = "22042282";
    KnNumber["num_22042283"] = "22042283";
    KnNumber["num_22042284"] = "22042284";
    KnNumber["num_22042285"] = "22042285";
    KnNumber["num_22042286"] = "22042286";
    KnNumber["num_22042288"] = "22042288";
    KnNumber["num_22042290"] = "22042290";
    KnNumber["num_22042291"] = "22042291";
    KnNumber["num_22042293"] = "22042293";
    KnNumber["num_22042294"] = "22042294";
    KnNumber["num_22042295"] = "22042295";
    KnNumber["num_22042296"] = "22042296";
    KnNumber["num_22042297"] = "22042297";
    KnNumber["num_22042298"] = "22042298";
    KnNumber["num_22042910"] = "22042910";
    KnNumber["num_22042922"] = "22042922";
    KnNumber["num_22042923"] = "22042923";
    KnNumber["num_22042924"] = "22042924";
    KnNumber["num_22042926"] = "22042926";
    KnNumber["num_22042927"] = "22042927";
    KnNumber["num_22042928"] = "22042928";
    KnNumber["num_22042932"] = "22042932";
    KnNumber["num_22042938"] = "22042938";
    KnNumber["num_22042978"] = "22042978";
    KnNumber["num_22042979"] = "22042979";
    KnNumber["num_22042980"] = "22042980";
    KnNumber["num_22042981"] = "22042981";
    KnNumber["num_22042982"] = "22042982";
    KnNumber["num_22042983"] = "22042983";
    KnNumber["num_22042984"] = "22042984";
    KnNumber["num_22042985"] = "22042985";
    KnNumber["num_22042986"] = "22042986";
    KnNumber["num_22042988"] = "22042988";
    KnNumber["num_22042990"] = "22042990";
    KnNumber["num_22042991"] = "22042991";
    KnNumber["num_22042993"] = "22042993";
    KnNumber["num_22042994"] = "22042994";
    KnNumber["num_22042995"] = "22042995";
    KnNumber["num_22042996"] = "22042996";
    KnNumber["num_22042997"] = "22042997";
    KnNumber["num_22042998"] = "22042998";
    KnNumber["num_22043010"] = "22043010";
    KnNumber["num_22043096"] = "22043096";
    KnNumber["num_22043098"] = "22043098";
    KnNumber["num_22051010"] = "22051010";
    KnNumber["num_22051090"] = "22051090";
    KnNumber["num_22059010"] = "22059010";
    KnNumber["num_22059090"] = "22059090";
    KnNumber["num_22060010"] = "22060010";
    KnNumber["num_22060031"] = "22060031";
    KnNumber["num_22060039"] = "22060039";
    KnNumber["num_22060051"] = "22060051";
    KnNumber["num_22060059"] = "22060059";
    KnNumber["num_22060081"] = "22060081";
    KnNumber["num_22060089"] = "22060089";
    KnNumber["num_22071000"] = "22071000";
    KnNumber["num_22072000"] = "22072000";
    KnNumber["num_22082012"] = "22082012";
    KnNumber["num_22082014"] = "22082014";
    KnNumber["num_22082016"] = "22082016";
    KnNumber["num_22082018"] = "22082018";
    KnNumber["num_22082019"] = "22082019";
    KnNumber["num_22082026"] = "22082026";
    KnNumber["num_22082028"] = "22082028";
    KnNumber["num_22082062"] = "22082062";
    KnNumber["num_22082066"] = "22082066";
    KnNumber["num_22082069"] = "22082069";
    KnNumber["num_22082086"] = "22082086";
    KnNumber["num_22082088"] = "22082088";
    KnNumber["num_22083011"] = "22083011";
    KnNumber["num_22083019"] = "22083019";
    KnNumber["num_22083030"] = "22083030";
    KnNumber["num_22083041"] = "22083041";
    KnNumber["num_22083049"] = "22083049";
    KnNumber["num_22083061"] = "22083061";
    KnNumber["num_22083069"] = "22083069";
    KnNumber["num_22083071"] = "22083071";
    KnNumber["num_22083079"] = "22083079";
    KnNumber["num_22083082"] = "22083082";
    KnNumber["num_22083088"] = "22083088";
    KnNumber["num_22084011"] = "22084011";
    KnNumber["num_22084031"] = "22084031";
    KnNumber["num_22084039"] = "22084039";
    KnNumber["num_22084051"] = "22084051";
    KnNumber["num_22084091"] = "22084091";
    KnNumber["num_22084099"] = "22084099";
    KnNumber["num_22085011"] = "22085011";
    KnNumber["num_22085019"] = "22085019";
    KnNumber["num_22085091"] = "22085091";
    KnNumber["num_22085099"] = "22085099";
    KnNumber["num_22086011"] = "22086011";
    KnNumber["num_22086019"] = "22086019";
    KnNumber["num_22086091"] = "22086091";
    KnNumber["num_22086099"] = "22086099";
    KnNumber["num_22087010"] = "22087010";
    KnNumber["num_22087090"] = "22087090";
    KnNumber["num_22089011"] = "22089011";
    KnNumber["num_22089019"] = "22089019";
    KnNumber["num_22089033"] = "22089033";
    KnNumber["num_22089038"] = "22089038";
    KnNumber["num_22089041"] = "22089041";
    KnNumber["num_22089045"] = "22089045";
    KnNumber["num_22089048"] = "22089048";
    KnNumber["num_22089054"] = "22089054";
    KnNumber["num_22089056"] = "22089056";
    KnNumber["num_22089069"] = "22089069";
    KnNumber["num_22089071"] = "22089071";
    KnNumber["num_22089075"] = "22089075";
    KnNumber["num_22089077"] = "22089077";
    KnNumber["num_22089078"] = "22089078";
    KnNumber["num_22089091"] = "22089091";
    KnNumber["num_22089099"] = "22089099";
    KnNumber["num_24021000"] = "24021000";
    KnNumber["num_24022010"] = "24022010";
    KnNumber["num_24022090"] = "24022090";
    KnNumber["num_24029000"] = "24029000";
    KnNumber["num_24031100"] = "24031100";
    KnNumber["num_24031910"] = "24031910";
    KnNumber["num_24031990"] = "24031990";
    KnNumber["num_24039100"] = "24039100";
    KnNumber["num_24039990"] = "24039990";
    KnNumber["num_27071000"] = "27071000";
    KnNumber["num_27072000"] = "27072000";
    KnNumber["num_27073000"] = "27073000";
    KnNumber["num_27075000"] = "27075000";
    KnNumber["num_27101211"] = "27101211";
    KnNumber["num_27101215"] = "27101215";
    KnNumber["num_27101221"] = "27101221";
    KnNumber["num_27101225"] = "27101225";
    KnNumber["num_27101231"] = "27101231";
    KnNumber["num_27101241"] = "27101241";
    KnNumber["num_27101245"] = "27101245";
    KnNumber["num_27101249"] = "27101249";
    KnNumber["num_27101250"] = "27101250";
    KnNumber["num_27101270"] = "27101270";
    KnNumber["num_27101290"] = "27101290";
    KnNumber["num_27101911"] = "27101911";
    KnNumber["num_27101915"] = "27101915";
    KnNumber["num_27101921"] = "27101921";
    KnNumber["num_27101925"] = "27101925";
    KnNumber["num_27101929"] = "27101929";
    KnNumber["num_27101931"] = "27101931";
    KnNumber["num_27101935"] = "27101935";
    KnNumber["num_27101943"] = "27101943";
    KnNumber["num_27101946"] = "27101946";
    KnNumber["num_27101947"] = "27101947";
    KnNumber["num_27101948"] = "27101948";
    KnNumber["num_27101951"] = "27101951";
    KnNumber["num_27101955"] = "27101955";
    KnNumber["num_27101962"] = "27101962";
    KnNumber["num_27101966"] = "27101966";
    KnNumber["num_27101967"] = "27101967";
    KnNumber["num_27102011"] = "27102011";
    KnNumber["num_27102016"] = "27102016";
    KnNumber["num_27102019"] = "27102019";
    KnNumber["num_27102032"] = "27102032";
    KnNumber["num_27102038"] = "27102038";
    KnNumber["num_27102090"] = "27102090";
    KnNumber["num_27111211"] = "27111211";
    KnNumber["num_27111219"] = "27111219";
    KnNumber["num_27111291"] = "27111291";
    KnNumber["num_27111293"] = "27111293";
    KnNumber["num_27111294"] = "27111294";
    KnNumber["num_27111297"] = "27111297";
    KnNumber["num_27111310"] = "27111310";
    KnNumber["num_27111330"] = "27111330";
    KnNumber["num_27111391"] = "27111391";
    KnNumber["num_27111397"] = "27111397";
    KnNumber["num_27111400"] = "27111400";
    KnNumber["num_27111900"] = "27111900";
    KnNumber["num_29011000"] = "29011000";
    KnNumber["num_29022000"] = "29022000";
    KnNumber["num_29023000"] = "29023000";
    KnNumber["num_29024100"] = "29024100";
    KnNumber["num_29024200"] = "29024200";
    KnNumber["num_29024300"] = "29024300";
    KnNumber["num_29024400"] = "29024400";
    KnNumber["num_29051100"] = "29051100";
    KnNumber["num_38111110"] = "38111110";
    KnNumber["num_38111190"] = "38111190";
    KnNumber["num_38111900"] = "38111900";
    KnNumber["num_38119000"] = "38119000";
    KnNumber["num_38248900"] = "38248900";
    KnNumber["num_38249200"] = "38249200";
    KnNumber["num_38249986"] = "38249986";
    KnNumber["num_38249992"] = "38249992";
    KnNumber["num_38249993"] = "38249993";
    KnNumber["num_38249996"] = "38249996";
    KnNumber["num_38260010"] = "38260010";
    KnNumber["num_38260090"] = "38260090";
})(KnNumber || (exports.KnNumber = KnNumber = {}));
var ExciseProductCode;
(function (ExciseProductCode) {
    ExciseProductCode["B000"] = "B000";
    ExciseProductCode["W200"] = "W200";
    ExciseProductCode["W300"] = "W300";
    ExciseProductCode["I000"] = "I000";
    ExciseProductCode["S200"] = "S200";
    ExciseProductCode["S300"] = "S300";
    ExciseProductCode["S400"] = "S400";
    ExciseProductCode["S500"] = "S500";
    ExciseProductCode["S600"] = "S600";
})(ExciseProductCode || (exports.ExciseProductCode = ExciseProductCode = {}));
/**
 * order type bör ändras över tid
 */
var OrderType;
(function (OrderType) {
    OrderType["Order"] = "Order";
    OrderType["Backorder"] = "Backorder";
    OrderType["ReturnOrder"] = "ReturnOrder";
})(OrderType || (exports.OrderType = OrderType = {}));
var TransportProvider;
(function (TransportProvider) {
    TransportProvider["POSTNORD"] = "POSTNORD";
    TransportProvider["BUDCOMPANIETT"] = "BUDCOMPANIETT";
    TransportProvider["DLP"] = "DLP";
    TransportProvider["DSV"] = "DSV";
})(TransportProvider || (exports.TransportProvider = TransportProvider = {}));
var DeliveryPalletType;
(function (DeliveryPalletType) {
    DeliveryPalletType["SRS_EUR6"] = "SRS_EUR6";
    DeliveryPalletType["SRS_EPAL"] = "SRS_EPAL";
    DeliveryPalletType["EPAL"] = "EPAL";
    DeliveryPalletType["QUARTER_PALLET"] = "QUARTER_PALLET";
    DeliveryPalletType["EUR6"] = "EUR6";
    DeliveryPalletType["OTHER"] = "OTHER";
})(DeliveryPalletType || (exports.DeliveryPalletType = DeliveryPalletType = {}));
var OrderFlowType;
(function (OrderFlowType) {
    OrderFlowType["standard"] = "standard";
    OrderFlowType["email"] = "email";
    OrderFlowType["freshx"] = "freshx";
})(OrderFlowType || (exports.OrderFlowType = OrderFlowType = {}));
var DeviationReason;
(function (DeviationReason) {
    DeviationReason["ORDER_LINE_IS_ADDED"] = "ORDER_LINE_IS_ADDED";
    DeviationReason["ORDER_LINE_IS_CHANGED"] = "ORDER_LINE_IS_CHANGED";
    DeviationReason["ORDER_LINE_IS_ACCEPTED"] = "ORDER_LINE_IS_ACCEPTED";
    DeviationReason["ORDER_LINE_IS_REJECTED"] = "ORDER_LINE_IS_REJECTED";
    DeviationReason["ORDER_LINE_IS_ALREADY_DELIVERED"] = "ORDER_LINE_IS_ALREADY_DELIVERED";
})(DeviationReason || (exports.DeviationReason = DeviationReason = {}));
var TargetWarehouse;
(function (TargetWarehouse) {
    TargetWarehouse["vinden"] = "vinden";
    TargetWarehouse["exacta"] = "exacta";
})(TargetWarehouse || (exports.TargetWarehouse = TargetWarehouse = {}));
/**
 * What has happened?
 */
var ComplaintType;
(function (ComplaintType) {
    ComplaintType["customerGotWrongOrder"] = "customerGotWrongOrder";
    ComplaintType["wrongArticles"] = "wrongArticles";
    ComplaintType["wrongPrices"] = "wrongPrices";
    ComplaintType["missingArticles"] = "missingArticles";
    ComplaintType["articlesBrokenInTransport"] = "articlesBrokenInTransport";
    ComplaintType["articleDoesNotMeetQualityExpectations"] = "articleDoesNotMeetQualityExpectations";
    ComplaintType["lostInDelivery"] = "lostInDelivery";
    ComplaintType["cancelledDueToLateHandling"] = "cancelledDueToLateHandling";
    ComplaintType["other"] = "other";
})(ComplaintType || (exports.ComplaintType = ComplaintType = {}));
var Color;
(function (Color) {
    Color["primary"] = "primary";
    Color["secondary"] = "secondary";
    Color["info"] = "info";
    Color["success"] = "success";
    Color["warning"] = "warning";
    Color["danger"] = "danger";
})(Color || (exports.Color = Color = {}));
/**
 * Used to calculate alcohol tax if applicable
 */
var AlcoholTaxClass;
(function (AlcoholTaxClass) {
    AlcoholTaxClass["Alcoholfree"] = "Alcoholfree";
    AlcoholTaxClass["Beer"] = "Beer";
    AlcoholTaxClass["Wine"] = "Wine";
    AlcoholTaxClass["MidRange"] = "MidRange";
    AlcoholTaxClass["Spirits"] = "Spirits";
})(AlcoholTaxClass || (exports.AlcoholTaxClass = AlcoholTaxClass = {}));
var ShelfLife;
(function (ShelfLife) {
    ShelfLife["short"] = "short";
    ShelfLife["medium"] = "medium";
    ShelfLife["long"] = "long";
    ShelfLife["special"] = "special";
})(ShelfLife || (exports.ShelfLife = ShelfLife = {}));
var RecycleType;
(function (RecycleType) {
    RecycleType["none"] = "none";
    RecycleType["PET1"] = "PET1";
    RecycleType["PET2"] = "PET2";
    RecycleType["aluminiumCan"] = "aluminiumCan";
    RecycleType["glassBottle33cl"] = "glassBottle33cl";
    RecycleType["glassBottle50cl"] = "glassBottle50cl";
    RecycleType["other"] = "other";
})(RecycleType || (exports.RecycleType = RecycleType = {}));
/**
 * shows state in orderflow
 */
var OrderState;
(function (OrderState) {
    OrderState["draft"] = "draft";
    OrderState["created"] = "created";
    OrderState["received"] = "received";
    OrderState["waitingForRestock"] = "waitingForRestock";
    OrderState["waitingForAdvancePayment"] = "waitingForAdvancePayment";
    OrderState["approved"] = "approved";
    OrderState["approvedByDropshipSupplier"] = "approvedByDropshipSupplier";
    OrderState["inWarehouseProcess"] = "inWarehouseProcess";
    OrderState["readyForShipping"] = "readyForShipping";
    OrderState["enRoute"] = "enRoute";
    OrderState["delivered"] = "delivered";
    OrderState["returned"] = "returned";
    OrderState["invoiced"] = "invoiced";
})(OrderState || (exports.OrderState = OrderState = {}));
/**
 * State handling for where the orders are arriving from
 */
var OrderOrigin;
(function (OrderOrigin) {
    OrderOrigin["supplier"] = "supplier";
    OrderOrigin["export"] = "export";
    OrderOrigin["customer"] = "customer";
    OrderOrigin["systembolaget"] = "systembolaget";
    OrderOrigin["internal"] = "internal";
    OrderOrigin["whitelabel"] = "whitelabel";
    OrderOrigin["purchasing"] = "purchasing";
    OrderOrigin["stockfiller"] = "stockfiller";
    OrderOrigin["dropshipping"] = "dropshipping";
    OrderOrigin["returnToSupplier"] = "returnToSupplier";
})(OrderOrigin || (exports.OrderOrigin = OrderOrigin = {}));
/**
 * shows state in orderflow
 */
var ReportState;
(function (ReportState) {
    ReportState["created"] = "created";
    ReportState["sentToSupplier"] = "sentToSupplier";
    ReportState["invoiceRecievedFromSupplier"] = "invoiceRecievedFromSupplier";
    ReportState["invoiceCompleted"] = "invoiceCompleted";
})(ReportState || (exports.ReportState = ReportState = {}));
/**
 * shows state in orderflow
 */
var PurchaseOrderState;
(function (PurchaseOrderState) {
    PurchaseOrderState["draft"] = "draft";
    PurchaseOrderState["waitingForFlaivyApproval"] = "waitingForFlaivyApproval";
    PurchaseOrderState["sentToSupplier"] = "sentToSupplier";
    PurchaseOrderState["shipped"] = "shipped";
    PurchaseOrderState["received"] = "received";
    PurchaseOrderState["partialyDelivered"] = "partialyDelivered";
    PurchaseOrderState["delivered"] = "delivered";
})(PurchaseOrderState || (exports.PurchaseOrderState = PurchaseOrderState = {}));
/**
 * State handling for where the invoices are created from
 */
var InvoiceOrigin;
(function (InvoiceOrigin) {
    InvoiceOrigin["supplier"] = "supplier";
    InvoiceOrigin["export"] = "export";
    InvoiceOrigin["customer"] = "customer";
    InvoiceOrigin["systembolaget"] = "systembolaget";
    InvoiceOrigin["internal"] = "internal";
    InvoiceOrigin["whitelabel"] = "whitelabel";
    InvoiceOrigin["purchasing"] = "purchasing";
    InvoiceOrigin["stockfiller"] = "stockfiller";
    InvoiceOrigin["dropshipping"] = "dropshipping";
    InvoiceOrigin["returnToSupplier"] = "returnToSupplier";
})(InvoiceOrigin || (exports.InvoiceOrigin = InvoiceOrigin = {}));
var PriceType;
(function (PriceType) {
    PriceType["campaign"] = "campaign";
    PriceType["tender"] = "tender";
    PriceType["tenderCampaign"] = "tenderCampaign";
})(PriceType || (exports.PriceType = PriceType = {}));
var ResolutionType;
(function (ResolutionType) {
    ResolutionType["credit"] = "credit";
    ResolutionType["return"] = "return";
    ResolutionType["customerPayed"] = "customerPayed";
    ResolutionType["other"] = "other";
    ResolutionType["none"] = "none";
})(ResolutionType || (exports.ResolutionType = ResolutionType = {}));
var AssignedResponsibility;
(function (AssignedResponsibility) {
    AssignedResponsibility["warehouse"] = "warehouse";
    AssignedResponsibility["supplier"] = "supplier";
    AssignedResponsibility["flaivy"] = "flaivy";
    AssignedResponsibility["none"] = "none";
})(AssignedResponsibility || (exports.AssignedResponsibility = AssignedResponsibility = {}));
var ComplaintState;
(function (ComplaintState) {
    ComplaintState["received"] = "received";
    ComplaintState["inReview"] = "inReview";
    ComplaintState["resolved"] = "resolved";
})(ComplaintState || (exports.ComplaintState = ComplaintState = {}));
